import { render, staticRenderFns } from "./MenuTypeTabs.vue?vue&type=template&id=7ac2ccd4&"
import script from "./MenuTypeTabs.vue?vue&type=script&lang=js&"
export * from "./MenuTypeTabs.vue?vue&type=script&lang=js&"
import style0 from "./MenuTypeTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports